// removed by extract-text-webpack-plugin
module.exports = {"char-counter":"TextArea__char-counter","charCounter":"TextArea__char-counter","textarea-label":"TextArea__textarea-label","textareaLabel":"TextArea__textarea-label"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/TextArea/TextArea.scss
// module id = 1823
// module chunks = 8